import { Star } from "lucide-react";

export default function ReviewsScroll({ reviews = [] }) {
  const list = reviews.length ? reviews : [
    { author: "Sophie L.", role: "Orthophoniste Paris", rating: 5, text: "Matériel d'une qualité exceptionnelle." },
    { author: "Marc D.", role: "Instituteur Lyon", rating: 5, text: "Ressources précieuses pour ma classe ULIS." },
    { author: "Camille B.", role: "Orthopédagogue Bruxelles", rating: 5, text: "Service rapide, produits sélectionnés." },
    { author: "Léa M.", role: "AVS Toulouse", rating: 5, text: "Adapté et durable. Parfait pour mon quotidien." },
  ];
  const doubled = [...list, ...list];

  return (
    <div className="scroll-y-track" data-testid="hero-reviews-scroll">
      {doubled.map((r, i) => (
        <div key={i} className="py-3 border-b border-ink/5 last:border-0">
          <div className="flex items-center gap-1 mb-1.5">
            {Array.from({ length: r.rating || 5 }).map((_, k) => (
              <Star key={k} size={12} className="fill-coral text-coral" />
            ))}
          </div>
          <p className="text-sm leading-relaxed text-ink mb-2">« {r.text} »</p>
          <p className="text-xs text-ink-soft">
            <span className="font-medium text-ink">{r.author}</span> · {r.role}
          </p>
        </div>
      ))}
    </div>
  );
}
